import React, {Fragment, useState, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Cord
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Fab from '@material-ui/core/Fab'
import Box from '@material-ui/core/Box'

// Material-UI Lab
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'

// Material-UI Icon
import SaveIcon from '@material-ui/icons/Save'

// Material-UI Element
//import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Component
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import Legend from '../Legend/Legend'
import AttachmentChip from '../Chip/AttachmentChip'
import WebViewer from "../WebViewer/WebViewer"


// Custom Style
import {redColor, oceanBlueColor, grayColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import {viewRelatedItemFormStyle} from '../../styles/jss/components/drawingRegister/viewRelatedItemFormStyle'

// Global Function
// import {getFile} from "../../global/getPropertyInfo"

// Fetch Data
import {getRelatedItemType, getCoverType, getCompanyList, createUnpublish, createRelatedItem, getRelatedItemsDetail, updateRelatedItem} from '../../dataSource/drawingRegister'
import {fileDownload} from '../../dataSource/fileManager'


// Custom Style (Typography)
// const InboxTypography = withStyles({
// 	root: {
// 		"fontSize": 12,
// 		"fontWeight": 400,
// 		"color": "red",
// 	},
// }) (Typography)


const useStyles = makeStyles(theme => viewRelatedItemFormStyle(theme))

const ViewRelatedItemForm = props => {
	const {drawingDetailRecord, selectedRevisionSeq, selectedRelatedItemSeq, viewRelatedItemDialogHandleClose, setDrawingRefash} = props
	const classes = useStyles()
	const dispatch = useDispatch()

	// Redux Data
	// const relatedItemPropertyRedux = useSelector(state => state.relatedItemPropertyRedux)

	// State Variable
	const [relatedItemRecord, setRelatedItemRecord] = useState(null)
	const [relatedItemRecordProperty, setRelatedItemRecordProperty] = useState(null)
	const [webViewProps, setWebViewProps] = useState(null)
	const [relatedItemTypeRecord, setRelatedItemTypeRecord] = useState(null)
	const [relatedItemProperty, setRelatedItemProperty] = useState(null)
	const [coverTypeList, setCoverTypeList] = useState(null)
	const [drawingProperty, setDrawingProperty] = useState(null)
	const [validationErrors, setValidationErrors] = useState({})
	const [coverType, setCoverType] = useState(null)

	// Dialog contral state
	// const [fileManagerDialogOpen, setFileManagerDialogOpen] = useState(false)
	// const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false)

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	const drawingPropertyTemplate = {
		cover_type_seq: "",
		files: [],
	
		cover: {
			ai_cover_no: "",
			ai_issue_date: "",
			ai_company_seq: "-1",
			ai_cover_subject: "",
			bd_cover_no: "",
			bd_issue_date: "",
			bd_company_seq: "-1",
			bd_cover_subject: ""
		},
	}

	const relatedItemPropertyTemplate = {
		type_seq: null,
		rel_no: "",
		files: [],
		rel_desc: "",
		inout: "",
		company_seq: null
	}


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}


	const handleTextChange = event => {
		const {name, value} = event.target
		const res = {...relatedItemRecordProperty}
		res[name] = value

		setRelatedItemRecordProperty(res)

		// validate(res)
	}


	// Confirm Dialog Contral Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	const viewFileAction = (fileCat, fileSeq, filename) => {
		setWebViewProps({
			file_cat: fileCat,
			file_ref: fileSeq,
			file_name: filename,
			from: "API",
			autoLoading: false,
		})
	}

	const downloadFileAction = (fileCat, fileSeq) => {
		fileDownload(fileCat, fileSeq).then(res => {
			console.log("*****************************************************************************")
			console.log("System Module: Document Submission")
			console.log("Message: File download successful.")
			console.log("*****************************************************************************")
		})
	}


	// Action
	const updateRelatedItemConfirmAction = () => {
		confirmDialogHandleOpen({
			dialogTitle: "Update Related Item",
			dialogContent: "Are you sure to save change.",
			confirmAction: updateRelatedItemAction,
			cancelAction: updateRelatedItemCancelAction
		})
	}

	const updateRelatedItemAction = () => {

		updateRelatedItem(drawingDetailRecord.dwg_seq, selectedRevisionSeq, selectedRelatedItemSeq, relatedItemRecordProperty).then(res => {
			confirmDialogHandleClose()
			
			if (res.type === "success") {
				setDrawingRefash(res.code)
				
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "success",
					title: "Success Alert",
					content: "The Related Item record have been updated"
				})

				setTimeout(() => {
					viewRelatedItemDialogHandleClose()
				}, 2000)
			}
			else {
				buildAlert({
					// Alert Type: success, info, warning, error
					type: "error",
					title: "Error Alert",
					content: res.message
				})
			}
		}).catch(error => {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "error",
				title: "Error Alert",
				content: error.message
			})
		})
	}

	const updateRelatedItemCancelAction = () => {
		confirmDialogHandleClose()
	}


	// Input Validation
	const validate = (fieldValues = drawingProperty) => {
		let temp = {...validationErrors}
	
		if (coverType && coverType.contain_ai) {
			if ("ai_cover_no" in fieldValues.cover) {
				temp.ai_cover_no = fieldValues.cover.ai_cover_no ? "" : "This field is required"
			}
	
			if ("ai_issue_date" in fieldValues.cover) {
				temp.ai_issue_date = fieldValues.cover.ai_issue_date ? "" : "This field is required"
			}
	
			if ("ai_company_seq" in fieldValues.cover) {
				temp.ai_company_seq = fieldValues.cover.ai_company_seq ? "" : "This field is required"
			}
	
			if ("ai_cover_subject" in fieldValues.cover) {
				temp.ai_cover_subject = fieldValues.cover.ai_cover_subject ? "" : "This field is required"
			}
		}

		if (coverType && coverType.contain_bd) {
			if ("bd_cover_no" in fieldValues.cover) {
				temp.bd_cover_no = fieldValues.cover.bd_cover_no ? "" : "This field is required"
			}
	
			if ("bd_issue_date" in fieldValues.cover) {
				temp.bd_issue_date = fieldValues.cover.bd_issue_date ? "" : "This field is required"
			}
	
			if ("bd_company_seq" in fieldValues.cover) {
				temp.bd_company_seq = fieldValues.cover.bd_company_seq ? "" : "This field is required"
			}
	
			if ("bd_cover_subject" in fieldValues.cover) {
				temp.bd_cover_subject = fieldValues.cover.bd_cover_subject ? "" : "This field is required"
			}
		}

		// if ("cover_type_seq" in fieldValues) {
		// 	temp.cover_type_seq = fieldValues.cover_type_seq ? "" : "This field is required"
		// }

		if ("files" in fieldValues) {
			temp.files = fieldValues.files.length > 0 ? "" : "This field is required"
		}

		setValidationErrors({...temp})

		if (fieldValues == drawingProperty) {
			return Object.values(temp).every(x => x == "")
		}
	}

	
	useEffect(() => {
		setRelatedItemProperty(relatedItemPropertyTemplate)

		getRelatedItemsDetail(drawingDetailRecord.dwg_seq, selectedRevisionSeq, selectedRelatedItemSeq).then(res => {
			setRelatedItemRecord(res.data[0])
			setRelatedItemRecordProperty(res.data[0])
		})

		setDrawingProperty(drawingPropertyTemplate)
		dispatch({
			type: "ADD_DRAWING_PROPERTY",
			data: drawingPropertyTemplate
		})
		
		getCoverType().then(res => {
			setCoverTypeList(res)
		})
		.catch(error => {
			console.error("Get cover type list error: ", error)
		})
	}, [])

	useEffect(() => {
		if (relatedItemRecord) {
			getRelatedItemType().then(res => {
				res.map(type => {
					if (type.relative_type_group_name === relatedItemRecord.group_name) {
						setRelatedItemTypeRecord(type)
					}
				})
			})
		}
	}, [relatedItemRecord])


	return (
		// console.log("Selected Drawing Detail Record | Variable: drawingDetailRecord (viewRelatedItemForm.js)"),
		// console.log(drawingDetailRecord),

		// console.log("Selected Related Item Record | Variable: selectedRelatedItemSeq (viewRelatedItemForm.js)"),
		// console.log(selectedRelatedItemSeq),

		// console.log("Related Item Detail Record | Variable: relatedItemRecord (viewRelatedItemForm.js)"),
		// console.log(relatedItemRecord),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				{/* <FullScreenDialog
					open={fileManagerDialogOpen}
					dialogTitle={"File Choice From eFiling"}
					formContent={
						<Efiling fileManagerType={"select"} />   // main => Main File Manager, select => Select File From File Manager
					}
					button={fileManagerDialogBtn}
					handleClose={fileManagerDialogHandleClose}
				/> */}

				{/* <FullScreenDialog
					open={filePreviewDialogOpen}
					dialogTitle={"Drawing Preview"}
					formContent={
						<FilePreview 
							filePreviewProperty={filePreviewProperty}
						/>
					}
					button={[]}
					handleClose={filePreviewDialogHandleClose}
				/> */}
			</div> 

			{
				relatedItemRecord ?
					<Grid container spacing={1} className={classes.fieldGridArea}>
						<Grid item xs={12} sm={12} lg={4}>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<ToggleButtonGroup
									aria-label="Related Item Type"
									exclusive
									value={relatedItemRecord.type_seq}
									// onChange={handleRelatedType}
									className={classes.ToggleButtonGroup}
								>
									{
										relatedItemTypeRecord ?
											relatedItemTypeRecord.relative_types.map((res, index) => {
												return (
													<ToggleButton
														key={index}
														aria-label={res.relative_type_name}
														disabled
														value={res.relative_type_seq}
														className={classes.ToggleButton_50}
													>
														<Typography color="textSecondary">{res.relative_type_name}</Typography>
													</ToggleButton>
												)
											})
										: ""
									}
								</ToggleButtonGroup>
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<TextField
									id="rel_no"
									name="rel_no"
									label="Ref No."
									required
									fullWidth={true}
									size="small"
									variant="outlined"
									value={relatedItemRecordProperty ? relatedItemRecordProperty.rel_no : ""}
									onChange={handleTextChange}
									InputLabelProps={{
										shrink: true,
									}}
									// error={validationErrors.ai_cover_subject && validationErrors.ai_cover_subject !== "" ? true : false}
									// helperText={validationErrors.ai_cover_subject}
								/>
							</Grid>

							<Grid item xs={12} sm={12} lg={12} className={classes.fieldGrid}>
								<TextField
									id="rel_desc"
									name="rel_desc"
									label="Description"
									required
									fullWidth={true}
									size="small"
									variant="outlined"
									value={relatedItemRecordProperty ? relatedItemRecordProperty.rel_desc : ""}
									onChange={handleTextChange}
									InputLabelProps={{
										shrink: true,
									}}
									// error={validationErrors.ai_cover_subject && validationErrors.ai_cover_subject !== "" ? true : false}
									// helperText={validationErrors.ai_cover_subject}
								/>
							</Grid>

							<div className={classes.LegendArea}>
								<Grid item xs={12} sm={12} lg={12}>
									<Legend
										id="files"
										label="Files *"
										required={true}

										normalTitleColor={grayColor[10]}
										normalBorderColor={grayColor[4]}
										messageTitleColor={redColor[6]}
										messageBorderColor={redColor[6]}

										// error={validationErrors.files && validationErrors.files !== "" ? true : false}
										// helperText={validationErrors.files}
									>
										<Box className={classes.addFileBtnArea}>
											{
												relatedItemRecord.items.map(res => {
													return (
														<AttachmentChip
															key={res.item_seq}
															id={res.item_seq}
															filename={res.filename}
															fileSize={null}
															fileExtension={res.extension}
															viewFileAction={() => viewFileAction(res.file_cat, res.item_seq, res.filename)}
															downloadFileAction={() => downloadFileAction(res.file_cat, res.item_seq)}
															fileRemoveAction={null}
														/>
													)
												})
											}
										</Box>
									</Legend>
								</Grid>
							</div>

							<Grid container spacing={1} className={classes.toolMenu}>
								<Grid item xs={12} sm={12} lg={12}>
									<Tooltip title="Save">
										<Fab 
											color="primary"
											size="small"
											onClick={updateRelatedItemConfirmAction}
											className={classes.toolMenuBtn}
										>
											<SaveIcon />
										</Fab>
									</Tooltip>
								</Grid>
							</Grid>

						</Grid>

						<Grid item xs={12} sm={12} lg={8}>
							<WebViewer 
								property={webViewProps}
							/>
						</Grid>
					</Grid>
				: ""
			}
		</Fragment>
	)
}


export default ViewRelatedItemForm